import React from 'react'
import { ActionChip, MenuOverlay } from '@fs/zion-ui'
import { ControlSettingsAdjust } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import SourceCentricToolsMenuItems from '../tools/SourceCentricToolsMenuItems'

type Props = {
  'data-testid'?: string
  /** Namespaces the menu's item test ids; see SourceCentricToolsMenuItems. */
  testIdPrefix?: string
}

export default function ToolsMenuOverlay({
  'data-testid': dataTestId = 'banner-tools-menu',
  testIdPrefix,
}: Props): JSX.Element {
  const [t] = useTranslation()

  return (
    <MenuOverlay
      menuButton={
        <ActionChip
          Icon={ControlSettingsAdjust}
          data-testid={dataTestId}
          label={t('tree-person.tools.label')}
          linkName="Person Header Tools Menu"
        />
      }
      aria-label={t('tree-person.tools.label')}
      inline={false}
    >
      <SourceCentricToolsMenuItems testIdPrefix={testIdPrefix} />
    </MenuOverlay>
  )
}
